"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Set up the final Client Profiler beacon just before the user leaves the page
 * for any reason, including navigating away from the page, switching apps,
 * hiding the browser, etc. The final beacon will only fire once per session.
 *
 * We detect when the user leaves the page by listening for the following
 * events:
 *
 *   - `visibilitychange` - [Most reliable cross browser][], device, and OS
 *   - `pagehide` - Supports for [bfcache][], and [fallback for Safari][]
 *   - `beforeunload` - [Fallback for everything else][]
 *
 * [Most reliable cross browser]: https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
 * [bfcache]: https://web.dev/bfcache/#apis-to-observe-bfcache
 * [fallback for Safari]: https://caniuse.com/mdn-api_document_visibilitychange_event
 * [Fallback for everything else]: https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
 *
 * @param beacon - A Client Profiler instance beacon method
 * @param callback - Optional callback to call with the triggering event
 */
function registerFinalBeacon(beacon, callback = () => { }) {
    // Bail if we're not in a browser environment. See PERF-802.
    if (typeof window === 'undefined')
        return;
    let isSessionComplete = false;
    const { addEventListener, document: doc } = window;
    function execFinalBeaconOnce(event) {
        if (isSessionComplete)
            return;
        callback(event);
        beacon({ isFinalBeacon: true });
        isSessionComplete = true;
    }
    // This should be the most universal "final" event
    addEventListener('visibilitychange', (event) => {
        if (doc.visibilityState === 'hidden')
            execFinalBeaconOnce(event);
    });
    // Fallback for Safari
    addEventListener('pagehide', execFinalBeaconOnce);
    // Fallback for everything else
    addEventListener('beforeunload', execFinalBeaconOnce);
}
exports.default = registerFinalBeacon;
